import { render, staticRenderFns } from "./SnippetItem.vue?vue&type=template&id=177c6eba&scoped=true&"
import script from "./SnippetItem.vue?vue&type=script&lang=js&"
export * from "./SnippetItem.vue?vue&type=script&lang=js&"
import style0 from "./SnippetItem.vue?vue&type=style&index=0&id=177c6eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c6eba",
  null
  
)

export default component.exports